import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import urlParse from 'url-parse';
import qs from 'querystringify';
import styled from '@emotion/styled';
import _Box from 'mineral-ui/Box';
import AppSideBar from './AppSideBar';
import AppTopBar from './AppTopBar';
import { Box } from '..';
import { getUserDetails } from '../../modules/selectors';

const propTypes = {
  children: PropTypes.node.isRequired,
  user: PropTypes.shape({
    agentNpn: PropTypes.string,
    token: PropTypes.string,
    userId: PropTypes.string,
    userRole: PropTypes.string,
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};
const defaultProps = {
  user: null,
};

export const APP_TOP_BAR_HEIGHT = '3.5em';
export const APP_SIDE_BAR_WIDTH = '15em';

const BoxDark = styled(_Box)(props => ({
  backgroundColor: props.theme.backgroundColor_page,
  minHeight: `calc(100vh - ${APP_TOP_BAR_HEIGHT})`,
}));

function AppFrame({
  children, user, location: { search },
}) {
  let appSideBar = null;
  let appSideBarWidth = 0;
  const { query } = urlParse(search);
  const { frameless } = qs.parse(query);
  if (frameless !== undefined) {
    // do not render frame components
    return (
      <div>
        {children}
      </div>
    );
  }

  // Only display the sidebar when logged in
  if (user) {
    appSideBar = <AppSideBar width={APP_SIDE_BAR_WIDTH} offset={APP_TOP_BAR_HEIGHT} />;
    appSideBarWidth = APP_SIDE_BAR_WIDTH;
  }
  return (
    <React.Fragment>
      <AppTopBar height={APP_TOP_BAR_HEIGHT} sideBarWidth={APP_SIDE_BAR_WIDTH} />
      <Box marginTop={APP_TOP_BAR_HEIGHT}>
        {appSideBar}
        <BoxDark marginLeft={appSideBarWidth} paddingVertical="1.5em" paddingHorizontal="2.5em">
          {children}
        </BoxDark>
      </Box>
    </React.Fragment>
  );
}


function mapStateToProps(state) {
  return {
    user: getUserDetails(state),
  };
}
AppFrame.propTypes = propTypes;
AppFrame.defaultProps = defaultProps;
// We need to wrap the redux connected component so that the children routes work
// Otherwise the component will not update unless the redux state triggers an update
// See https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
export default withRouter(connect(mapStateToProps)(AppFrame));
